export var PAGE_TYPE;
(function(PAGE_TYPE) {
    PAGE_TYPE["DISCOVER"] = "discover";
    PAGE_TYPE["BRAND"] = "brand";
    PAGE_TYPE["PRODUCT"] = "product";
    PAGE_TYPE["CATEGORY"] = "category";
    PAGE_TYPE["HOMEPAGE"] = "homepage";
})(PAGE_TYPE || (PAGE_TYPE = {}));
